"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.preview.title': '价格套餐详情',
    'accountGrade.preview.back': '返回价格套餐',
    'accountGrade.preview.edit': '编辑价格套餐',
    'accountGrade.preview.delete': '删除价格套餐',
    'accountGrade.preview.enabled': '已启用',
    'accountGrade.preview.disabled': '已禁用',
    'accountGrade.preview.no_data': '无价格套餐数据可用',
    'accountGrade.preview.error.load_failed': '预览价格套餐加载失败',
    'accountGrade.preview.unnamed': '未命名价格套餐',
    'accountGrade.preview.no_description': '未提供描述',
    'accountGrade.preview.price': '月价格',
    'accountGrade.preview.free': '免费',
    'accountGrade.preview.cents': '分',
};
